// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-heading {
  font-family: "Poppins", sans-serif;
  font-size: 38px;
  font-weight: 700;
}
.carousel-inner{
  background-color: #4733C9;
  border-radius: 20px;
}
.carousel-inner-text{
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 30px;
  color: #ffffff;
}
.carousel-inner-text-2 {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #ffffff;
}

/* @media (max-width: 600px) {
  .carousel-heading {
    font-size: 14px;
  }

  .carousel-inner-text-2 {
    font-size: 14px;
  }
} */

.homepage-carousel .carousel-indicators {
  position: absolute;
  bottom: -5%;
  left: 66% !important;
  right: 0;
  margin-left: auto;
  margin-right: 0;
  width: 33%;
  display: flex;
  justify-content: center;
 }

.homepage-carousel .carousel-indicators li {
  background-color: #707070;
  border: 1px solid #ffffff;
   border-radius: 50%;
   width: 10px;
   height: 10px;
   margin: 0 2px;
   cursor: pointer;
  transition: background-color 0.3s ease;
  list-style: none;
 }

.homepage-carousel .carousel-indicators li.active {
  background-color: #09ed0d;
  /* Active indicator color */
  width: 15px;
  border-radius: 45%;
}
@media (max-width:768px) {
  .carousel-div-home{
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: center;
}
  .responsive-img{
    width: 50%;
    /* min-width: 320px; */
    height: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CarouselComponent/homepagecarousel.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,aAAa;EACb,uBAAuB;CACxB;;AAED;EACE,yBAAyB;EACzB,yBAAyB;GACxB,kBAAkB;GAClB,WAAW;GACX,YAAY;GACZ,aAAa;GACb,eAAe;EAChB,sCAAsC;EACtC,gBAAgB;CACjB;;AAED;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;AACpB;AACA;EACE;EACA,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;AACzB;EACE;IACE,UAAU;IACV,sBAAsB;IACtB,YAAY;EACd;AACF","sourcesContent":[".carousel-heading {\n  font-family: \"Poppins\", sans-serif;\n  font-size: 38px;\n  font-weight: 700;\n}\n.carousel-inner{\n  background-color: #4733C9;\n  border-radius: 20px;\n}\n.carousel-inner-text{\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 30px;\n  color: #ffffff;\n}\n.carousel-inner-text-2 {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  color: #ffffff;\n}\n\n/* @media (max-width: 600px) {\n  .carousel-heading {\n    font-size: 14px;\n  }\n\n  .carousel-inner-text-2 {\n    font-size: 14px;\n  }\n} */\n\n.homepage-carousel .carousel-indicators {\n  position: absolute;\n  bottom: -5%;\n  left: 66% !important;\n  right: 0;\n  margin-left: auto;\n  margin-right: 0;\n  width: 33%;\n  display: flex;\n  justify-content: center;\n }\n\n.homepage-carousel .carousel-indicators li {\n  background-color: #707070;\n  border: 1px solid #ffffff;\n   border-radius: 50%;\n   width: 10px;\n   height: 10px;\n   margin: 0 2px;\n   cursor: pointer;\n  transition: background-color 0.3s ease;\n  list-style: none;\n }\n\n.homepage-carousel .carousel-indicators li.active {\n  background-color: #09ed0d;\n  /* Active indicator color */\n  width: 15px;\n  border-radius: 45%;\n}\n@media (max-width:768px) {\n  .carousel-div-home{\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  justify-content: center;\n}\n  .responsive-img{\n    width: 50%;\n    /* min-width: 320px; */\n    height: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
